export const headers = [
  {
    name: 'Instituição',
    field: 'institution.company_social_name',
    sortable: true
  },
  {
    name: 'Cliente',
    field: 'client.name',
    sortable: true
  },
  {
    name: 'Estudante',
    field: 'student.name',
    sortable: true
  },
  { name: 'Valor Total', field: 'value_payament', sortable: true },
  { name: 'Situação', field: 'situation', sortable: true },
  {
    name: 'Último acesso',
    field: 'client.last_access_at',
    sortable: true
  },
  { name: 'Ações', field: 'actions', sortable: false }
]
